<template>
  <input-container
    class="input-container-phone"
    :label="label"
    :assistive="assistive"
    :no-assistive="noAssistive"
    :classes="classes"
    :body-styles="{ overflow: 'unset' }"
    :class="{ focused, disabled, invalid, isSingle }">
    <template #container>
      <vSelect
        v-model="selectedCountry"
        :clearable="false"
        :searchable="false"
        class="v-select-phone"
        label="code"
        :options="countries"
        :no-drop="isSingle"
      >
        <template #option="{ code, flag }">
          <div class="d-flex justify-content-start align-items-center p-l-12">
            <!-- <Photo :source="flag" width="24px" height="24px" size="cover"/> -->
            <span class="font text-base leading-6 f-w-700 m-l-8">{{ code }}</span>
          </div>
        </template>

        <template #selected-option="{ code, flag }">
          <div class="d-flex justify-content-start align-items-center p-l-12">
            <Photo :source="flag" width="24px" height="24px" size="cover"/>
            <span class="font text-base leading-6 f-w-700 m-l-8">{{ code }}</span>
          </div>
        </template>

      </vSelect>

      <InputComponent
        ref="input"
        :placeholder="placeholder"
        :name="name"
        v-model="input"
        @focus="focus"
        @blur="blur"
        :disabled="disabled"
        :delay="delay"
        :sanitize="sanitize"
      />
      <slot name="icon-right"></slot>
      <button type="button" class="btn fab fab-sm m-r-16 inline-flex items-center justify-center" v-if="showCleanButton" @click="clear">
        <UIcon name="i-pkg-action-close" class="size-4 text-primary-500" />
      </button>
      <span class="font mr-3 leading-6 text-base f-w-500" v-if="enhancerLabel">{{ enhancerLabel }}</span>
    </template>
  </input-container>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import InputContainer from './input-container.vue';
import InputComponent from './input-component.vue';
// import Photo from '../Image/image.vue';
import UsCaFlag from '~/assets/images/flags/us-ca.png';

const countries = [
  { name: 'ca', code: '+1', flag: UsCaFlag },
];

export default {
  components: {
    InputContainer,
    InputComponent,
    vSelect,
    // Photo,
  },
  data() {
    return {
      focused: false,
      selectedCountry: countries[0],
    };
  },
  props: {
    countries: {
      type: Array,
      default: () => ([...countries]),
    },
    noAssistive: {
      type: Boolean,
      default: false,
    },
    enhancerLabel: {
      type: [Boolean, String],
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
    clean: {
      type: Boolean,
      default: false,
    },
    value: {},
    label: {
      type: [String, Boolean],
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    assistive: {
      type: [String, Boolean],
      default: false,
    },
    error: {
      type: [Boolean, String, Array],
      default: false,
    },
    classes: {
      type: String,
      default: 'p-b-32',
    },
    sanitize: {
      type: Function,
      default: (v) => v,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    delay: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isSingle() {
      return this.countries.length === 1;
    },
    showCleanButton() {
      return !this.disabled && this.clean && this.value.length;
    },
    invalid() {
      return Boolean(this.error || this.error.length);
    },
    input: {
      get() {
        const { code } = this.selectedCountry;
        return this.value?.toString().replace(code, '');
      },
      set(input) {
        const number = input?.toString().replace(/\D/g, '');
        const { code } = this.selectedCountry;

        this.$emit('input', `${code}${number}`);
      },
    },
  },
  methods: {
    focus(focus) {
      this.focused = focus;
    },
    blur(blur) {
      this.focused = blur;
    },
    clear() {
      this.$refs.input.clear();
    },
  },
};
</script>

<style lang="scss">
.input-container-phone {
  &.isSingle {
    .v-select-phone {
      width: 60px;
    }
  }

  .input {
    height: 100%;
    border-radius: 5px;
  }
  .v-select-phone {
    cursor: pointer;
    width: 120px;
    border: unset;
    height: 100%;
    .vs__dropdown-toggle {
      height: 100% !important;
      padding: 0px;
      border: unset;
      .vs__selected-options {
        padding: unset;
        .vs__selected {
          margin: 0px;
          padding: 0px;
          height: 100%;
        }
      }
    }
  }
}
</style>
